"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MqlScope = void 0;
var mathApi = {
    pow: function (base, exponent) { return Math.pow(base, exponent); },
    pi: function () { return Math.PI; },
    sum: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return args.reduce(function (acc, cur) { return acc + cur; }, 0);
    },
    min: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Math.min.apply(Math, __spreadArray([], __read(args), false));
    },
    max: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Math.max.apply(Math, __spreadArray([], __read(args), false));
    },
    avg: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return args.reduce(function (acc, cur) { return acc + cur; }, 0) / args.length;
    },
    roundTo: function (value, precision) {
        var factor = Math.pow(10, precision);
        return Math.round(value * factor) / factor;
    },
    round: function (value) { return Math.round(value); },
    floor: function (value) { return Math.floor(value); },
    ceil: function (value) { return Math.ceil(value); },
    abs: function (value) { return Math.abs(value); },
    sqrt: function (value) { return Math.sqrt(value); },
    // Remember that Math.sin, Math.cos and Math.tan expect radians
    sin: function (value) { return Math.sin(value); },
    cos: function (value) { return Math.cos(value); },
    tan: function (value) { return Math.tan(value); },
};
// MqlFunctions receive the item being evaluated as the last arg, math functions do not need it
var dropLastArg = function (fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.apply(void 0, __spreadArray([], __read(args.slice(0, -1)), false));
    };
};
var prepareMathApi = function (api) {
    return Object.fromEntries(Object.entries(api).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], fn = _b[1];
        return [key, dropLastArg(fn)];
    }));
};
var toLowerCaseKeys = function (obj) {
    return Object.fromEntries(Object.entries(obj).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return [key.toLowerCase(), value];
    }));
};
var MqlScopeDefaultImpl = /** @class */ (function () {
    function MqlScopeDefaultImpl(functions, symbols) {
        this.functions = toLowerCaseKeys(functions);
        this.symbols = toLowerCaseKeys(symbols);
    }
    MqlScopeDefaultImpl.prototype.getFunction = function (name) {
        return this.functions[name.trim().toLowerCase()];
    };
    MqlScopeDefaultImpl.prototype.listFunctions = function () {
        return Object.keys(this.functions);
    };
    MqlScopeDefaultImpl.prototype.getSymbol = function (name) {
        return this.symbols[name.trim().toLowerCase()];
    };
    MqlScopeDefaultImpl.prototype.listSymbols = function () {
        return Object.keys(this.symbols);
    };
    return MqlScopeDefaultImpl;
}());
var MqlScopeBuilder = /** @class */ (function () {
    function MqlScopeBuilder() {
        this.functions = {};
        this.symbols = {};
    }
    MqlScopeBuilder.prototype.addFunction = function (name, func) {
        this.functions[name] = func;
        return this;
    };
    MqlScopeBuilder.prototype.addFunctions = function (funcs) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(funcs)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                this.addFunction(key, value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this;
    };
    MqlScopeBuilder.prototype.addSymbol = function (name, value) {
        this.symbols[name] = value;
        return this;
    };
    MqlScopeBuilder.prototype.addSymbols = function (symbols) {
        var e_2, _a;
        try {
            for (var _b = __values(Object.entries(symbols)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                this.addSymbol(key, value);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return this;
    };
    MqlScopeBuilder.prototype.build = function () {
        return new MqlScopeDefaultImpl(this.functions, this.symbols);
    };
    return MqlScopeBuilder;
}());
exports.MqlScope = Object.freeze({
    createBlank: function () {
        return new MqlScopeBuilder();
    },
    createDefault: function () {
        return this.createBlank()
            .addFunctions(prepareMathApi(mathApi));
    },
});
